<template>
  <div>
    <div class="admin_topbar">
      <div class="admin_topbar_mainblock">
        <h1 class="header">Инвентарь</h1>
        <div class="filters">
          <label class="show_checkbox__wrapper">
            <input
              type="checkbox"
              class="checkbox"
              v-model="inventoryShowArchived"
            />
            <CheckboxIcon></CheckboxIcon>
            <span class="show_checkbox">Показывать списанные</span>
          </label>
          <div class="search-field__wrapper">
            <input
              class="search-field"
              type="text"
              v-model="inventoryFilter"
              placeholder="Поиск по названию, проекту или сотруднику"
            />
            <i
              class="material-icons-outlined"
              v-if="inventoryFilter"
              @click="inventoryFilter = ''"
              >close</i
            ><SearchIcon></SearchIcon>
          </div>
          <a
            class="button1"
            title="Добавить оборудование"
            @click="addInventory"
          >
            Добавить оборудование
          </a>
        </div>
      </div>
    </div>
    <div class="view">
      <table>
        <thead>
          <th>Название</th>
          <th>Тип оборудовния</th>
          <th>Ответственный сотрудник</th>
          <th>Название проекта</th>
          <th>Действия</th>
        </thead>
        <tbody>
          <tr
            class="inventory-entry"
            v-for="mech of filteredInventory"
            :key="mech.id"
            :class="{ 'grey-text': mech.writeOffReason }"
            @click="renderFullData(mech)"
          >
            <td>{{ mech.name }}</td>
            <td>{{ mech.type.name }}</td>
            <td>{{ mech.manager ? mech.manager.name : "На складе" }}</td>
            <td>{{ mech.project ? mech.project.name : "На складе" }}</td>
            <td @click.stop="handleControl" class="row-control-buttons">
              <VerticalDots></VerticalDots>
              <div class="dots_menu">
                <p @click.stop="archiveInventory(mech)">
                  <ArchiveIcon></ArchiveIcon> Архивировать
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="modal" class="modal_right" v-if="isModal1Active">
      <div class="modal_bg"></div>
      <div class="modal_content">
        <h4 class="header">Карточка оборудования</h4>
        <div class="table__wrapper">
          <table>
            <tr>
              <th>Наименование</th>
              <td v-if="currentInventory.edit">
                <input type="text" v-model="currentInventory.name" />
              </td>
              <td v-else>{{ currentInventory.name }}</td>
            </tr>
            <tr>
              <th>Раздел</th>
              <td v-if="currentInventory.edit">
                <select v-model="currentInventory.type">
                  <option v-for="type in typeList" :key="type.id" :value="type">
                    {{ type.name }}
                  </option>
                </select>
              </td>
              <td v-else>
                {{ currentInventory.type && currentInventory.type.name }}
              </td>
            </tr>
            <tr>
              <th>Комплектация</th>
              <td v-if="currentInventory.edit">
                <input type="text" v-model="currentInventory.equipment" />
              </td>
              <td v-else>{{ currentInventory.equipment }}</td>
            </tr>
            <tr>
              <th>Серийный номер</th>
              <td v-if="currentInventory.edit">
                <input type="text" v-model="currentInventory.sn" />
              </td>
              <td v-else>{{ currentInventory.sn }}</td>
            </tr>
            <tr v-if="currentInventory.writeOffReason">
              <th>Причина списания</th>
              <td>{{ currentInventory.writeOffReason }}</td>
            </tr>
            <tr v-if="!currentInventory.writeOffReason">
              <th>Сотрудник</th>
              <td v-if="currentInventory.edit">
                <select v-model="currentInventory.manager">
                  <option
                    v-for="manager in managerList"
                    :key="manager.id"
                    :value="manager"
                  >
                    {{ manager.name }}
                  </option>
                </select>
              </td>
              <td
                v-else
                v-text="
                  currentInventory.manager
                    ? currentInventory.manager.name
                    : ' На складе'
                "
              ></td>
            </tr>
            <tr v-if="!currentInventory.writeOffReason">
              <th>Объект</th>
              <td v-if="currentInventory.edit">
                <select v-model="currentInventory.project">
                  <option
                    v-for="project in projectList"
                    :key="project.id"
                    :value="project"
                  >
                    {{ project.name }}
                  </option>
                </select>
              </td>
              <td
                v-else
                v-text="
                  currentInventory.project
                    ? currentInventory.project.name
                    : ' На складе'
                "
              ></td>
            </tr>
          </table>
        </div>

        <card-timeline
          :timeline="currentInventory.timeline"
          timelineType="inventory"
        ></card-timeline>

        <div class="modal_buttons_block">
          <a
            class="button1"
            @click="handleEdit()"
            v-if="!currentInventory.edit && !currentInventory.writeOffReason"
            >Редактировать</a
          >
          <a @click="isModal1Active = false" class="modal-close button2">{{
            currentInventory.edit ? "Отмена" : "Закрыть"
          }}</a>
          <a
            class="modal-close button1"
            v-if="currentInventory.edit"
            @click="uploadData"
            :class="{
              disabled: !currentInventory.name || !currentInventory.type,
            }"
          >
            Сохранить
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import CardTimeline from "../components/CardTimeline.vue";
import SearchIcon from "../components/Icons/SearchIcon";
import CheckboxIcon from "../components/Icons/CheckboxIcon";
import ArchiveIcon from "../components/Icons/ArchiveIcon";
import VerticalDots from "../components/Icons/VerticalDots";

export default {
  components: {
    CardTimeline,
    SearchIcon,
    CheckboxIcon,
    ArchiveIcon,
    VerticalDots,
  },
  mounted() {
    // const elems = document.querySelectorAll(".modal");
    // M.Modal.init(elems, {
    //   // onCloseStart: this.uploadData,
    // });
    // this.modal = M.Modal.getInstance(elems[0]);

    this.initInventory();
  },
  data: () => {
    return {
      inventoryFilter: "",
      inventoryShowArchived: false,
      modal: {},
      currentInventory: { edit: false },
      typeList: [],
      managerList: [],
      projectList: [],
      inventory: [],
      isModal1Active: false,
    };
  },
  computed: {
    filteredInventory() {
      return this.inventory.filter(
        (i) =>
          (String(i.name)
            .toLowerCase()
            .startsWith(this.inventoryFilter.toLowerCase()) ||
            String(i.manager)
              .toLowerCase()
              .startsWith(this.inventoryFilter.toLowerCase()) ||
            String(i.project)
              .toLowerCase()
              .startsWith(this.inventoryFilter.toLowerCase())) &&
          (!i.writeOffReason || this.inventoryShowArchived)
      );
    },
  },
  methods: {
    addInventory() {
      this.currentInventory = { edit: true };
      this.isModal1Active = true;
      //this.modal.open();
      // this.modal.el.querySelector(".modal-content").scrollTop = 0;
      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        M.FormSelect.init(elems, {});
      }, 0);
    },
    handleControl(e) {
      document.querySelectorAll(".dots_menu").forEach((el) => {
        if (el !== e.currentTarget.querySelector(".dots_menu")) {
          el.style.display = "none";
        }
      });
      if (
        e.currentTarget.querySelector(".dots_menu").style.display === "none"
      ) {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "flex");
      } else {
        e.currentTarget
          .querySelector(".dots_menu")
          .style.setProperty("display", "none");
      }
    },
    renderFullData(mech) {
      this.currentInventory = mech;
      this.currentInventory.edit = false;
      this.isModal1Active = true;

      //this.modal.open();
      //this.modal.el.querySelector(".modal-content").scrollTop = 0;
    },
    handleEdit() {
      this.currentInventory.edit = true;
      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        M.FormSelect.init(elems, {});
      }, 0);
    },
    archiveInventory(mech) {
      let conf = true;
      if (mech.project || mech.manager) {
        conf = confirm("Перед списанием инвентарь будет перемещён на склад!");
      }
      if (conf && (mech.writeOffReason = prompt("Укажите причину списания"))) {
        delete mech.project;
        delete mech.manager;
        mech.edit = true;
        this.currentInventory = mech;
        this.uploadData();
      }
    },
    unarchiveInventory(mech) {
      delete mech.writeOffReason;
      mech.edit = true;
      this.currentInventory = mech;
      this.uploadData();
    },
    async initInventory() {
      let resp = await fetch("/backend/inventory.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getInventory",
        }),
      });
      const inventory = await resp.json();
      this.inventory = inventory;

      resp = await fetch("/backend/projects.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getProjects",
          notArchived: true,
        }),
      });
      const projects = await resp.json();
      this.projectList = projects.map(({ id, name }) => {
        return { id, name };
      });
      this.projectList.unshift({ id: 0, name: "На складе" });

      resp = await fetch("/backend/inventory.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getInventoryTypes",
        }),
      });
      const types = await resp.json();
      this.typeList = types;

      resp = await fetch("/backend/employees.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getEmployees",
          notArchived: true,
        }),
      });
      const employees = await resp.json();
      this.managerList = employees.map(({ id, name, surname, patronymic }) => {
        return { id, name: name + " " + patronymic + " " + surname };
      });
      this.managerList.unshift({ id: 0, name: "На складе" });

      resp = await fetch("/backend/inventory.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getTimelineInventory",
          inventory: this.inventory.map(({ id }) => {
            return id;
          }),
        }),
      });
      const timeline = await resp.json();
      timeline.forEach((i) => {
        i.manager = this.managerList.find((j) => j.id == i.manager)?.name;
        i.project = this.projectList.find((j) => j.id == i.project)?.name;

        const inventoryEntry = this.inventory.find((j) => j.id == i.inventory);

        inventoryEntry.timeline
          ? inventoryEntry.timeline.push(i)
          : (inventoryEntry.timeline = [i]);
      });
    },
    async uploadData() {
      if (this.currentInventory.edit) {
        const resp = await fetch("/backend/inventory.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("isLogged"),
          },
          body: JSON.stringify({
            action: "setInventory",
            inventory: {
              id: this.currentInventory.id ? this.currentInventory.id : null,
              name: this.currentInventory.name,
              type: this.currentInventory.type.id,
              equipment: this.currentInventory.equipment,
              sn: this.currentInventory.sn,
              project: this.currentInventory.project
                ? this.currentInventory.project.id
                : null,
              manager: this.currentInventory.manager
                ? this.currentInventory.manager.id
                : null,
              writeOffReason: this.currentInventory.writeOffReason
                ? this.currentInventory.writeOffReason
                : null,
            },
          }),
        });
        const id = await resp.text();
        if (id != 0 && id != this.currentInventory.id) {
          this.currentInventory.id = id;
          this.inventory.push(this.currentInventory);
        }
      }
    },
  },
  watch: {
    currentInventory: {
      handler(val, newVal) {
        if (newVal.project && newVal.project.id == 0) {
          delete this.currentInventory.project;
        }
        if (newVal.manager && newVal.manager.id == 0) {
          delete this.currentInventory.manager;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
.white-space {
  width: calc(100% - 130px);
  height: 60px;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  top: 0;
  left: 130px;
}

.filters {
  display: flex;
  justify-content: space-between;
}

.inventory-filter {
  width: 350px;
  position: relative;
  & i {
    position: absolute;
    right: 0;
  }
}

.inventory-entry:hover {
  background-color: #eee;
}

.row-control-buttons {
  width: 90px;
}

.table-button {
  border: 1px solid silver;
  cursor: pointer;
  color: #000000DE;
}

.modal-footer .btn-flat {
  background-color: #a5d6a7;
  margin-left: 5px;

  &:hover {
    background-color: #81c784;
  }
}
</style>
